export enum SortType {
    DATE_DESC = 'DATE_DESC',
    DATE_ASC = 'DATE_ASC',
    PRICE_DESC = 'PRICE_DESC',
    PRICE_ASC = 'PRICE_ASC',
    MODIFICATION_DATE = 'MODIFICATION_DATE',
    PRICE_PER_SQUARE_METER_ASC = 'PRICE_PER_SQUARE_METER_ASC',
    PRICE_PER_SQUARE_METER_DESC = 'PRICE_PER_SQUARE_METER_DESC'
}
